import { palette } from '../palette';

const getPrimaryColor = () => {
  const brandingJson = localStorage.getItem('branding');
  if (brandingJson) {
    const branding = JSON.parse(brandingJson);
    return branding?.primaryColors ?? palette.primary;
  }
  return palette.primary;
};

export const MuiTab = {
  styleOverrides: {
    root: {
      borderRadius: '8px 8px 0px 0px',
      color: palette.custom.gray[500],
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '14px',
      lineHeight: '20px',
      textTransform: 'none',
      fontWeight: 600,
      marginRight: '4px',
      height: '32px',
      minHeight: '32px',
      '&:hover':{
        backgroundColor: palette.custom.gray[100],
      },
      '&.Mui-selected': {
        color: getPrimaryColor()[700],
        backgroundColor: getPrimaryColor()[50],
        fontWeight: 600,
        '&:hover': {
          color: getPrimaryColor()[800],
          backgroundColor: getPrimaryColor()[100],
        },
      },
    },
  },
};

export const MuiTabs = {
  defaultProps: {
    scrollButtons: 'auto',
    allowScrollButtonsMobile: true,
    fullWidth: true,
  },
  styleOverrides: {
    root: {
      borderBottom: '1px solid',
      borderColor: palette.custom.gray[200], 
      height: '32px',
      minHeight: '32px',
    },
    indicator: {
      // display: 'none',
    },
  },
};